import { TbShieldLock } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const permissionGroupsRoutes: NavigationRoute[] = [
  {
    to: APP_ROUTES_TO.PERMISSION_GROUPS,
    meta: {
      label: "permission_groups",
      order: 6,
      icon: TbShieldLock,
      visibleInSidebar: true,
      permissions: [PERMISSIONS.AUTH_SVC_PERMISSIONS_GROUPS_LIST],
    },
  },
];
